import Container from 'react-bootstrap/Container';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import '../style/footer.css'

function Footer(){
    const { t } = useTranslation();

    return(
        <Container fluid className='page-footer'>
            <div className='footer-links'>
                <Link to='/mentions-legales' className='footer-link'>
                    {t('footer.legalNotice')}
                </Link>
            </div>
            <div className='copyright'>
                {t('footer.copyright')}
            </div>
        </Container>
    );
}

export default Footer;